module.exports = __webpack_public_path__ + "media/svg-new/svg-layout-591c2eeb.svg";